import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'BatteryIndicator',
  label: 'Battery Indicator',
  icon: 'DocumentTextIcon',
  description: 'Fields for a Battery Indicator',
  properties: [
    {
      label: 'Percentage',
      name: 'percent',
      editor: 'number',
      readonly: false,
      description: 'The percentage fullness of the battery',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Tailwind Class',
      name: 'classes',
      editor: 'textbox',
      readonly: false,
      description: 'Tailwind classes to apply to the image',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
